import { PhotoItemObject } from '@pages/gallery/PhotoItemObject';
import gallery01 from '@assets/images/gallery/gallery01.webp';
import gallery02 from '@assets/images/gallery/gallery02.webp';
import gallery03 from '@assets/images/gallery/gallery03.webp';
import gallery04 from '@assets/images/gallery/gallery04.webp';
import gallery05 from '@assets/images/gallery/gallery05.webp';
import gallery06 from '@assets/images/gallery/gallery06.webp';
import gallery07 from '@assets/images/gallery/gallery07.webp';
import gallery08 from '@assets/images/gallery/gallery08.webp';
import gallery09 from '@assets/images/gallery/gallery09.webp';
import gallery10 from '@assets/images/gallery/gallery10.webp';
import gallery11 from '@assets/images/gallery/gallery11.webp';
import gallery12 from '@assets/images/gallery/gallery12.webp';
import gallery13 from '@assets/images/gallery/gallery13.webp';
import gallery14 from '@assets/images/gallery/gallery14.webp';
import gallery15 from '@assets/images/gallery/gallery15.webp';



export const galleryItems: PhotoItemObject[] = [
	{
		image: gallery01,
		text: 'Nádor sleziny, který vyndali z\u00a0bříška tohohle chlupáče, měl přes neuvěřitelná 4\u00a0kila. Pan Zdeněk neváhal a pro límec k\u00a0nám zajel ve\u00a0chvíli, kdy jeho pejsek ležel na\u00a0operačním sále. Všechno dobře dopadlo!',
		name: '',
	},
	{
		image: gallery02,
		text: '„Límec přišel a jsme všichni šťastný!“',
		name: 'Petr',
	},
	{
		image: gallery03,
		text: '„Sárinka už pomalu našlapuje na\u00a0nožku. Už se s\u00a0límcem pohybuje, jako by k\u00a0ní patřil. Jsem moc ráda, že jsem jí\u00a0ho objednala. Je to teď takový její polštář. Super nápad.“',
		name: 'Ivana',
	},
	{
		image: gallery04,
		text: '„Je vidět, jaký s\u00a0vašim límcem udělal pokrok a\u00a0hlavně, že si v\u00a0něm i odpočinul. Už jsem opravdu nedoufala, že\u00a0to zachráníme. Vždy to vypadalo, že\u00a0už to bude lepší a Marty nám vždy ukázal jiný fígl, jak plastový límec zbořit a dostat se k\u00a0ráně.“',
		name: 'Alex',
	},
	{
		image: gallery05,
		text: '„...právě jsme přijeli z\u00a0kastrace a\u00a0navlékli mu to, a\u00a0naprostá pohoda\u00a0- už se zkoušel i lízat, a\u00a0túůůůdle! Váš límec v\u00a0tom dokonale zabránil... Mohu být v\u00a0klidu i přes noc!“',
		name: 'Katka',
	},
	{
		image: gallery06,
		text: '„Dobrý den, moc děkuji za rychlé zhotovení a dodání límce pro\u00a0našeho drobečka, který prodělal operaci levého kolena. Operace proběhla před 20\u00a0dny a fena je z\u00a0límce nadšená, opravdu v\u00a0něm může žrát, pít, a\u00a0hlavně na něm spí, má ho jako vynikající polštář, a\u00a0hlavně se nedostane tam kam\u00a0nemá.“',
		name: 'Skálovi',
	},
	{
		image: gallery07,
		text: 'A co vy? Vidíte ten rozdíl?',
		name: '',
	},
	{
		image: gallery08,
		text: '„Chtěla bych za\u00a0mě i Beretku strašně moc poděkovat za\u00a0nádherný límec! Límec jsme se rozhodli objednat z\u00a0důvodu kastrace a\u00a0bylo to jedno z\u00a0nejlepších rozhodnutí! Límec je skvělý, Beretka si na\u00a0něj velice rychle zvykla, když si lehne, tak ho má jako polštářek. Nepřekáží ji ani u\u00a0jídla či\u00a0pití...“',
		name: 'majitelka Beretky',
	},
	{
		image: gallery09,
		text: '„Chtěla jsem vám moc poděkovat za\u00a0zaslání límce pro\u00a0Kačenku. Je to geniální vynález, krásně vymyšlený a\u00a0precizně ušitý. Úplně\u00a0se uklidnila a už\u00a0vůbec neřeší, že je po\u00a0operaci. Naopak vypadá spokojeně, že\u00a0si nosí měkký polštářek stále s\u00a0sebou. Ještě jednou děkuju a\u00a0posílám fotky spokojené zákaznice“',
		name: 'Jana',
	},
	{
		image: gallery10,
		text: '„Dobrý den, chci Vám poděkovat, že\u00a0jste vymysleli tak super věc, jakou límec\u00a0je...“',
		name: 'Soňa',
	},
	{
		image: gallery11,
		text: 'Válení se v\u00a0postýlce, klidně i\u00a0s oblíbenou hračkou…. S VETlímcem žádný problém.',
		name: '',
	},
	{
		image: gallery12,
		text: 'Jeníček se může v\u00a0klidu vyvenčit. A třeba si počkat v\u00a0lese na\u00a0Mařenku.',
		name: '',
	},
	{
		image: gallery13,
		text: '„Límec je krásný, operace nás teprve čeká, tak\u00a0se pomalu připravujeme. Ještě jednou obrovský dík, jste úžasní.“',
		name: 'Renata',
	},
	{
		image: gallery14,
		text: 'Fešandy, kterým límeček pomohl při\u00a0rekonvalescenci po\u00a0kastraci. Ve dvou se\u00a0to lépe táhne!',
		name: '',
	},
	{
		image: gallery15,
		text: 'Maxík -\u00a0psí krasavec a\u00a0alergik zároveň. Kožní problémy jsou u\u00a0pejsků častější, než\u00a0se může zdát -\u00a0límec je v\u00a0tomto ohledu velký pomocník.',
		name: '',
	},
]